// import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
// import { testFormSpec } from '../../../../context/formSpec_patient';
import testLogo from '../../styles/assets/verisma_logo.png';
import './LogoAndTitle.scss';
import axios from "axios";
import { getwayApi } from "../../../../../config/Constants";

export const LogoAndTitle = ({
    config, titleText, formId, dbFormSpec, titleColor, logo, formType, formSubtype = "Patient Representative" }) => {

    let disclaimerText;
    if (dbFormSpec.TitleDisclaimerText) {
        let fontWeight = (dbFormSpec.TitleDisclaimerText.Bold) ? "bold" : "";
        let fontSize = (Number.parseInt(dbFormSpec.TitleDisclaimerText.FontSize, 10) || 12);

        disclaimerText = <div style={{ fontSize: fontSize, fontWeight: fontWeight }}>
            &nbsp; {dbFormSpec.TitleDisclaimerText.IncludeAsterix && <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2" cy="2" r="1.5" stroke="#B00020"></circle></svg>}
            {dbFormSpec.TitleDisclaimerText.Text}</div>;
    }

    return (
        <div id='logo-and-title-section' className=''>
            <img id='form-logo' style={{ width: dbFormSpec.logo.formWidth }} src={`${getwayApi}/api/client/logo/${formId}`} alt={dbFormSpec.logo.alt} />
            {/* {logo} */}
            <h4 className='page-title' >
                {formType && formType === "Representative" && <div className='form-type'>{formSubtype}</div>}
                {titleText}
                {disclaimerText}
            </h4>


        </div>
    )
}